import {createContext} from 'react'

export const ChromelessContext = createContext(false)
